import {registerMaterialGraphNode} from "#material/register"
import type {MaterialFrameSockets} from "#material/nodes/base/frame/definition"
import {materialFrameDefinition} from "#material/nodes/base/frame/definition"
import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {CyclesReturns} from "#material/sockets/cycles"
import type {ThreeReturns} from "#material/sockets/three"
import type {ThreeEvaluator, CyclesEvaluator} from "#material/nodes/base/material/types/evaluators"

@registerMaterialGraphNode
export class MaterialFrame extends MaterialNode<MaterialFrameSockets> {
    public override get definition() {
        return materialFrameDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<MaterialFrameSockets>> => {
        throw new Error("Three support for MaterialFrame is not implemented.")
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<MaterialFrameSockets>> => {
        throw new Error("Cycles support for MaterialFrame is not implemented.")
    }
}
